import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { SearchBoxComponent } from '../../components/search-box/search-box.component';
import { debounceTime } from 'rxjs';
import { PrintService } from 'src/app/services/print.service';

@Component({
  selector: 'app-barcode',
  templateUrl: './barcode-generator.component.html',
  styleUrl: './barcode-generator.component.css',
})
export class BarcodeGeneratorComponent implements OnInit {
  constructor(
    private logger: LoggerService,
    private modalService: NgbModal,
    private apiService: UserApiService,
    private printService: PrintService,
    private responseService: CustomizeResponseService
  ) {
    this.barcodeDataString =
      '010000000000000021000000000000000000001725100210403';

    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });

    this.searchRequestModel = new PCSearchRequestModel();
    this.getSearchEntity();
  }
  public barcodeDataString: string | undefined;
  public breadCrumb: string = 'Features,Barcode';
  public barcodeData = {
    GTN: '',
    UID: '',
    EXP: '',
    LOT: '',
  };
  public barcodeUniqueData = {
    drugId: '',
    companyName: '',
    country: '',
    EXP: '',
    drugName: '',
    drugEnglishName: '',
    drugGenericCode: '',
    drugPackageCount: 1,
  };

  public RadioButtonStatus: any;

  public modalIsOpen: boolean = false;
  public searchLoading: boolean = false;
  public printCount: number = 1;
  public drugSearchForm: FormGroup;
  public searchRequestModel: PCSearchRequestModel;
  public searchData?: PCTableInputModel;
  public searchPaging?: TabelPaging;
  @ViewChild('ScanBarcodeModal') ScanBarcodeModal!: NgbPopover;
  public searchFields: any[] = [];
  @ViewChild(SearchBoxComponent)
  searchBoxComponent!: SearchBoxComponent;
  public activeSearch: boolean = true;
  public exportBarcode: boolean = false;

  public ngOnInit(): void {
    this.drugSearchForm
      .get('drugBrandName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        this.barcodeUniqueData.drugGenericCode = '';
        if (this.activeSearch) {
          this.searchDrug(value);
        } else {
          this.activeSearch = true;
        }
      });
  }

  public ChangeBarcode() {
    this.exportBarcode=false;
    if (this.RadioButtonStatus == 'Normal') {
      const gtn =
        this.barcodeData.GTN.length > 14
          ? this.barcodeData.GTN.substring(0, 14)
          : this.barcodeData.GTN.padStart(14, '0');
      if (this.barcodeData.GTN.length > 14) this.barcodeData.GTN = gtn;

      const uid =
        this.barcodeData.UID.length > 20
          ? this.barcodeData.UID.substring(0, 20)
          : this.barcodeData.UID.padStart(20, '0');
      if (this.barcodeData.UID.length > 20) this.barcodeData.UID = uid;

      const exp =
        this.barcodeData.EXP.length > 8
          ? this.barcodeData.EXP.substring(0, 8)
          : this.barcodeData.EXP.padStart(8, '0');
      if (this.barcodeData.EXP.length > 8) this.barcodeData.EXP = exp;

      const lot =
        this.barcodeData.LOT.length > 10
          ? this.barcodeData.LOT.substring(0, 10)
          : this.barcodeData.LOT.padStart(10, '0');
      if (this.barcodeData.LOT.length > 10) this.barcodeData.LOT = lot;

      this.barcodeDataString = `01${gtn}21${uid}17${this.barcodeData.EXP}10${this.barcodeData.LOT}`;
    } else if (this.RadioButtonStatus == 'Unique') {
      const exp =
        this.barcodeUniqueData.EXP.length > 8
          ? this.barcodeUniqueData.EXP.substring(0, 8)
          : this.barcodeUniqueData.EXP.padStart(8, '0');
      if (this.barcodeUniqueData.EXP.length > 8)
        this.barcodeUniqueData.EXP = exp;

      const clearGuid =
        this.barcodeUniqueData.drugId.length == 36
          ? this.barcodeUniqueData.drugId
          : '00000000-0000-0000-0000-000000000000';

      this.barcodeDataString = `02|${clearGuid}|${this.barcodeUniqueData.EXP}`;
    }
  }

  public searchWithGenericCode() {
    this.barcodeUniqueData.drugName = '';
    if (this.barcodeUniqueData.drugGenericCode == null) {
      return;
    }
    try {
      this.searchLoading = true;

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      let url = `BuyFactor/AdvanceSearchByGenericCode?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${this.barcodeUniqueData.drugGenericCode}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.searchRequestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.searchRequestModel.orderBy,
              this.searchRequestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.searchLoading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.searchLoading = false;
    }
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          },
          (reason) => {
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          }
        );
    } catch (error) {}
  }

  public getSearchEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          'BuyFactor',
          null,
          undefined,
          `BuyFactor`,
          `DrugSearch`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog(`Barcode`, result, `Get Entity`);
          if (result.succeeded) {
            this.searchFields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.searchFields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            setTimeout(() => {
              if (this.searchBoxComponent) {
                this.searchBoxComponent.InitPage();
              } else {
                console.error('PCTableComponent not found');
              }
            }, 2);
            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
  }

  public parentSearchAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.searchLoading = true;
        if (this.searchRequestModel.orderBy == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.orderBy != event.data) {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == 'asd') {
          this.searchRequestModel.direction = 'desc';
        }

        this.searchRequestModel.orderBy = event.data;

        this.searchDrug(this.barcodeUniqueData.drugName!);
        break;
      case 'Paging':
        this.searchLoading = true;

        this.searchRequestModel.pageNumber = event.data;
        this.searchDrug(this.barcodeUniqueData.drugName!);
        break;
      case 'PageSize':
        this.searchLoading = true;
        this.searchRequestModel.pageSize = event.data;
        this.searchDrug(this.barcodeUniqueData.drugName!);
        break;
      case 'SelectItem':
        this.selectDrug(event.data);
        this.modalService.dismissAll();
        break;

      default:
        break;
    }
  }

  public searchDrug(drugName: string): void {
    try {
      this.searchLoading = true;

      if (!drugName) {
        return;
      }

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      let url = `BuyFactor/AdvanceSearch?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugName}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.searchData = undefined;
      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          this.searchBoxComponent.InitPage();
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.searchRequestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.searchRequestModel.orderBy,
              this.searchRequestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.searchLoading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.searchLoading = false;
    }
  }

  public selectDrug(item: any) {
    this.barcodeUniqueData.drugId = item.id;
    this.barcodeUniqueData.companyName = item.companyName; //persianName
    this.barcodeUniqueData.country = item.country; //persianName
    this.barcodeUniqueData.drugName = item.drugBrandPersianName; //persianName
    this.barcodeUniqueData.drugEnglishName = item.drugBrandName; //persianName
    this.barcodeUniqueData.drugPackageCount = item.drugPackageCount;
    this.modalIsOpen = false;
    this.activeSearch = false;
    this.RadioButtonStatus = 'Unique';
    this.ChangeBarcode();
    return;
  }

  public print() {
    this.exportBarcode=true;
    setTimeout(() => {
      this.publishPrint();   
    }, 100);
  }

  private publishPrint(){
    const barcodeContainer = document.querySelector('.barcode-container');
    if (barcodeContainer == null) {
      return;
    }
    const printWindow = window.open('', '', 'height=500,width=500');
    let containerHtml = `
      <style>
        img{
          width: 100%;
        }
        .barcode-print-box{
          width: 15mm;
          height: 15mm;
          margin-right: 5mm;
          margin-bottom: 5mm;
        }
      </style>
      <div style="display: flex; flex-wrap: wrap; justify-content: space-between;width: 80mm;">`;
    for (let index = 0; index < this.printCount; index++) {
      const barcodeHtml = barcodeContainer.outerHTML;
      const styledBarcodeHtml = `<div class="barcode-print-box">${barcodeHtml}</div>`;
      containerHtml += styledBarcodeHtml;
    }
    containerHtml += '</div>';
    printWindow!.document.write(containerHtml);
    
    setTimeout(() => {
      printWindow!.print();
      printWindow!.close();
    }, 200);

  }
}
